const breathing_rate_variability_chart_options = ({
    data
    // , xAxis, categories
}) => ({
    rangeSelector: {
        selected: 1
    },
    title: {
        text: "",
        align: "left"
    },
    subtitle: {
        text: "",
        align: "left"
    },
    chart: {
        zoomType: "x",
        // type: "line",
        panKey: "alt",
        panning: true,
        borderRadius: 8,
    },
    yAxis: {
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        labels: {
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        },
    },
    xAxis: {
        type: "datetime",
        ordinal: false,
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        scrollbar: {
            enabled: false
        },
        // plotBands: [{
        //     color: '#FCFFC5',
        //     from: Date.UTC(2010, 0, 2),
        //     to: Date.UTC(2010, 0, 4)
        // }],
        labels: {
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        },
    },
    series: [{
        name: "BR Variability",
        showInLegend: false,
        color: '#053D6E',
        data,
        gapSize: 2
    }],
    labels: {
        overflow: "scroll"
    },
    navigator: {
        enabled: false
    },
    scrollbar: {
        enabled: false
    },
    plotOptions: {
        line: {
            marker: {
                enabled: false
            }
        }
    },
    exporting: {
        enabled: true
    }
});

export default breathing_rate_variability_chart_options;
